const authToken = state => state.authToken;

export default authToken;
